import styled from 'styled-components';
import { rem } from 'polished';
import { EngineSelectTemplate } from './EngineSelectTemplate';
import { isBrandOV, isMarketGB } from 'src/constants/main';

const isOpel = isBrandOV && !isMarketGB;

export const EngineSelectStyled = styled(EngineSelectTemplate)`
    padding: ${rem(40)} 0 ${rem(40)} 0;
    position: relative;

    .currencyLabel__suffix--PM {
        padding-left: 0;
    }

    .isDisabled {
        pointer-events: none;
        opacity: 0.5;
    }

    .engineTitle,
    .engineDescription,
    .enginePrice {
        display: block;
    }

    .engines {
        position: relative;
    }

    .engine {
        border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};
        cursor: pointer;
        margin: ${rem(8)} 0;
        width: 100%;
        background: none;
        text-align: left;
        padding: 0;

        &.isSelected,
        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.primary};
            .inner {
                border-color: ${({ theme }) => theme.colors.primary};
            }
        }

        .inner {
            border: 1px solid transparent;
            padding: ${rem(24)} ${rem(24)} ${rem(24)} ${rem(64)};
        }
    }

    .engineTitle {
        color: ${({ theme }) => theme.colors.black2};
        font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        position: relative;

        .icon {
            border: 1px solid #73767a;
            width: ${rem(24)};
            height: ${rem(24)};
            position: absolute;
            left: -${rem(40)};
            top: -${rem(2)};
            border-radius: 50%;

            .selected {
                background: ${({ theme }) => theme.colors.primary};
                width: ${rem(12)};
                height: ${rem(12)};
                position: absolute;
                top: ${rem(5)};
                left: ${rem(5)};
                border-radius: 50%;
            }
        }
    }

    .engineDescription {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        color: ${({ theme }) => theme.colors.secondary};
        padding: ${rem(5)} ${rem(0)} ${rem(16)} ${rem(0)};
    }

    .enginePrice {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
    }

    .or {
        text-transform: lowercase;
    }

    .currencyLabel__suffix--TTC {
        padding-left: 0;
    }
`;
